<script>import { getIcon } from "../data/icons";
import { t, Verbiage } from "@infinitro/content";
const WarningNewIcon = getIcon("WarningNewIcon");
</script>

{#if typeof WarningNewIcon === 'string'}
	<img src={WarningNewIcon} alt={$t(Verbiage.warning_new_icon_alt, 'alts')} />
{:else if typeof WarningNewIcon === 'function'}
	<svelte:component this={WarningNewIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
